import { TeaserData } from "@app/types/ServerCustomContext";
import { configHome } from "@pub/config";
import placeholders from "@pub/placeholders";
import {
  Card,
  ImageCrop,
  NaturalCarousel,
  NaturalCarouselRef,
  ResponsiveImage,
} from "@sphtech/dmg-design-system";
import { useRef, useState } from "react";

import styles from "./fullwidthcarousel.module.css";

type Props = {
  teasers: TeaserData[];
  title: string;
  titleUrl: string;
  backgroundImage?: ImageCrop;
  backgroundColor?: string;
  textColor?: string;
};

const FullWidthCarousel = ({
  teasers,
  title,
  titleUrl,
  backgroundImage,
  backgroundColor,
  textColor,
}: Props) => {
  const carouselRef = useRef<NaturalCarouselRef>(null);
  const [position, setPosition] = useState(0);

  const onPositionChange = (newPosition: number) => {
    setPosition(newPosition);
  };

  return (
    <div
      className={styles.backgroundContainer}
      style={{ background: backgroundColor }}
    >
      {backgroundImage && (
        <div className={styles.imageContainer}>
          <ResponsiveImage {...backgroundImage} fill="cover" loading="lazy" />
        </div>
      )}

      <div className={styles.contentContainer}>
        <a href={titleUrl} className={styles.titleContainer}>
          <h2 className={styles.title} style={{ color: textColor }}>
            {title}
          </h2>
        </a>

        <div className={styles.carouselContainer}>
          <div className={styles.arrowsContainer}>
            {position !== 0 && (
              <button
                onClick={() => carouselRef.current?.previous()}
                className={styles.arrow}
              >
                {configHome.contentBlockCarousel?.leftIcon}
              </button>
            )}
            <button
              onClick={() => carouselRef.current?.next()}
              className={styles.arrow}
            >
              {configHome.contentBlockCarousel?.rightIcon}
            </button>
          </div>

          <NaturalCarousel
            ref={carouselRef}
            isLooping={false}
            hideAllArrows
            onPositionChange={onPositionChange}
          >
            {teasers.map((contentBlockItem, index) => {
              return (
                <div className={styles.cardContainer} key={index}>
                  <Card
                    {...contentBlockItem}
                    variant="card-stacked-portrait"
                    mobileUpVariant="card-stacked-portrait-mobile-up"
                    placeholders={placeholders}
                    displayPublishDate={false}
                    tags={undefined}
                  />
                </div>
              );
            })}
          </NaturalCarousel>
        </div>
      </div>
    </div>
  );
};

export default FullWidthCarousel;
